import { lazy } from "react";

export const DashboardPage = lazy(() => import("pages/dashboard"));
export const UsersPage = lazy(() => import("pages/users"));
export const DealersPage = lazy(() => import("pages/dealers"));
export const LoginPage = lazy(() => import("pages/auth/login"));
export const BrandsPage = lazy(() => import("pages/brands"));
export const CategoriesPage = lazy(() => import("pages/categories"));
export const GraphsPage = lazy(() => import("pages/graphs"));
export const OrdersPage = lazy(() => import("pages/orders"));
export const PromoPage = lazy(() => import("pages/promo"));
export const ProductsPage = lazy(() => import("pages/products"));
export const BundlesPage = lazy(() => import("pages/bundles"));
export const ReportsPage = lazy(() => import("pages/reports"));
export const NotFoundPage = lazy(() => import("pages/not-found"));
export const UploadPage = lazy(() => import("pages/upload"));
export const CustomInvoicingPage = lazy(() => import("pages/invoicing/custom-invoicing"));
export const InvoicingPage = lazy(() => import("pages/invoicing"));
export const CreateInvoicePage = lazy(() => import("pages/invoicing/CreateInvoicePage"));
export const InvoiceDetailsPage = lazy(() => import("pages/invoicing/InvoiceDetailsPage"));
export const ReviewsPage = lazy(() => import("pages/reviews"));
export const PaymentSuccessPage = lazy(() => import("pages/payment"));
export const BundleUpsertPage = lazy(() => import("pages/bundles/BundleUpsertPage"));